import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useParams,
} from "react-router-dom";

import { NavigationProvider } from "@context/NavigationContext";
import { UIProvider } from "@context/UIContext";

import Footer from "./components/Footer";
import Header from "./components/Header";
import {
  CommunityAuthProvider,
  useCommunityAuth,
} from "./auth/CommunityAuthContext";
import { SessionProvider } from "./context/SessionContext";
import Navigation from "./Navigation";
import EditProfilePage from "./pages/EditProfilePage";
import HomePage from "./pages/HomePage";
import ProfilePage from "./pages/ProfilePage";
import SophiaStorefrontPage from "./pages/SophiaStorefrontPage";
import UpdatePortfolioPage from "./pages/UpdatePortfolioPage";

const CommunityShell = ({ children }) => {
  const { user, loading } = useCommunityAuth();
  if (loading) return null;
  return (
    <SessionProvider currentUid={user?.uid}>
      {children}
    </SessionProvider>
  );
};

// Reads :uid from the URL and hands it to the reusable ProfilePage
const ProfileRoute = () => {
  const { uid } = useParams();
  return <ProfilePage uid={uid} />;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/profile/:uid" element={<ProfileRoute />} />
    <Route path="/me/edit" element={<EditProfilePage />} />
    <Route path="/me/portfolio" element={<UpdatePortfolioPage />} />

    {/* Sophia's storefront */}
    <Route path="/sophia-lan-storefront" element={<SophiaStorefrontPage />} />

    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

const AppContext = ({ children }) => (
  <UIProvider>
    <NavigationProvider>
      <CommunityAuthProvider>
        <CommunityShell>{children}</CommunityShell>
      </CommunityAuthProvider>
    </NavigationProvider>
  </UIProvider>
);

const App = () => (
  <Router>
    <AppContext>
      <Navigation>
        <Header />
        <AppRoutes />
        <Footer />
      </Navigation>
    </AppContext>
  </Router>
);

export default App;
